/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BannerInfo } from '../models/BannerInfo';
import type { LandingPageInfo } from '../models/LandingPageInfo';
import type { PopupInfo } from '../models/PopupInfo';
import type { ProjectBasicSettingInfo } from '../models/ProjectBasicSettingInfo';
import type { ProjectMenuInfo } from '../models/ProjectMenuInfo';
import type { TopNoticeInfo } from '../models/TopNoticeInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CommonControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns TopNoticeInfo OK
     * @throws ApiError
     */
    public getTopNoticeList(): CancelablePromise<Array<TopNoticeInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/common/top-notice',
        });
    }

    /**
     * @returns ProjectBasicSettingInfo OK
     * @throws ApiError
     */
    public getProjectBasicSetting(): CancelablePromise<ProjectBasicSettingInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/common/setting',
        });
    }

    /**
     * @returns ProjectMenuInfo OK
     * @throws ApiError
     */
    public getProjectMenuTree(): CancelablePromise<Array<ProjectMenuInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/common/project-menu',
        });
    }

    /**
     * @returns PopupInfo OK
     * @throws ApiError
     */
    public getPopupList(): CancelablePromise<Array<PopupInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/common/popup',
        });
    }

    /**
     * @returns LandingPageInfo OK
     * @throws ApiError
     */
    public getLanding(): CancelablePromise<LandingPageInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/common/landing',
        });
    }

    /**
     * @returns BannerInfo OK
     * @throws ApiError
     */
    public getBannerList(): CancelablePromise<Array<BannerInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/common/banner',
        });
    }

}
